export interface CommonZIndex {
    stickyVideo: number
    flyoutNav: number
    videoPlayButton: number
    videoTitleOverlay: number
    videoTopBar: number
    videoControlBar: number
    videoContextMenu: number
    mainNavigationListItem: number
    widgetLinkButtonIcon: number
    link: number
    collectionDividers: number
    toastNotification: number
}

export interface TheWestZindex {
    flyoutNav: number
    stickySiteHeader: number
    stickyFooter: number
    searchDropdown: number
    breachMobileVariant: number
    cardPlayButton: number
    featureHeadline: number
    mainNavContent: number
    mainNavScrollShadow: number
    stickyHeaderShadow: number
    liveBlogQuestionForm: number
    theWestLiveBanner: number
}

export interface PerthNowZindex {
    mainNavigation: number
    cardIcon: number
    cardImageHoverOutline: number
    stickyFooter: number
    stickySiteHeader: number
    linkHighlight: number
}

export interface SevenNewsZindex {
    globalNavLocationDropDown: number
    subNavDropDown: number
    stickySiteHeader: number
    mainNavContent: number
    cardPlayButton: number
    flyoutNav: number
    heroCardText: number
    mainNavScrollShadow: number
    cardKicker: number
    heroCardGradientOverlay: number
    stickyHeaderShadow: number
}

interface ZIndex {
    common: CommonZIndex
    thewest: TheWestZindex
    sevennews: SevenNewsZindex
    perthnow: PerthNowZindex
}

export const zIndex: ZIndex = {
    common: {
        toastNotification: 100001, // higher than all other numbers here
        stickyVideo: 199, // Should be higher than other sticky containers (except sticky header)
        flyoutNav: 31, // TODO: Why is this defined in common and in the west and seven?
        videoPlayButton: 20,
        videoTitleOverlay: 10,
        videoTopBar: 10,
        videoControlBar: 5,
        videoContextMenu: 8,
        mainNavigationListItem: 2,
        widgetLinkButtonIcon: 1,
        collectionDividers: 1,
        link: 0,
    },
    thewest: {
        flyoutNav: 202, // Higher than all components
        stickySiteHeader: 200, // Higher than sticky video
        liveBlogQuestionForm: 99,
        stickyFooter: 101,
        searchDropdown: 28,
        breachMobileVariant: 27, // Must sit below stickyFooter
        cardPlayButton: 20,
        featureHeadline: 10,
        mainNavContent: 2,
        mainNavScrollShadow: 1,
        stickyHeaderShadow: -1, // pseudo element
        theWestLiveBanner: 100,
    },
    sevennews: {
        globalNavLocationDropDown: 400,
        subNavDropDown: 300,
        stickySiteHeader: 200, // Higher than sticky video
        mainNavContent: 40,
        cardPlayButton: 50,
        flyoutNav: 50,
        heroCardText: 20,
        mainNavScrollShadow: 10,
        cardKicker: 11, // Needs to sit above the overlay
        heroCardGradientOverlay: 10,
        stickyHeaderShadow: -1, // pseudo element
    },
    perthnow: {
        mainNavigation: 30,
        cardIcon: 20,
        cardImageHoverOutline: 5,
        stickyFooter: 30,
        stickySiteHeader: 100000, // some takeover ads have a z-index of 99999 applied to them
        linkHighlight: -1, // pseudo elements for interaction states
    },
}
